import { render, staticRenderFns } from "./AdLg.vue?vue&type=template&id=4f6606ef&scoped=true"
import script from "./AdLg.vue?vue&type=script&lang=js"
export * from "./AdLg.vue?vue&type=script&lang=js"
import style0 from "./AdLg.vue?vue&type=style&index=0&id=4f6606ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6606ef",
  null
  
)

export default component.exports